var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppWebserch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.5px;}.cls-2{fill:#5c5fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18,
    cy: 18,
    r: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 18,
    r: 8.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.19,
    y1: 21.19,
    x2: 9.81,
    y2: 14.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.48,
    y1: 17.07,
    x2: 12.39,
    y2: 11.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.61,
    y1: 24.42,
    x2: 9.52,
    y2: 18.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.19,9.81c4.34,1.7-2.05,18.07-6.39,16.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.19,9.81c-4.34-1.7-10.73,14.68-6.39,16.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWebserch);
export default __webpack_public_path__ + "static/media/app_webserch.8e74acce08592f894caa5b8847db46e3.svg";
export { ForwardRef as ReactComponent };